// New ResumeRenderer — dispatches to one of 20 unique layouts and applies a theme.
//
// Props:
//   template:     slug from /api/cv/templates (each maps to {layout, theme, options})
//   data:         ResumeData (contact / summary / experience / …)
//   allTemplates: full template catalogue (for layout/theme/options lookup)

import React from "react";
import { LAYOUTS } from "./Layouts";
import { themeVars, THEMES } from "./themes";

const DEFAULT_OPTIONS = {
  photo_style:  "none",      // none | round | square | banner | sidebar
  skill_style:  "tags",      // bullets | tags | bars | dots | percent | stars
  sidebar_side: "left",      // left | right
  icons:        true,
  columns:      1,
  ats_mode:     false,
  qr_url:       "",
};

export default function ResumeRenderer({ template, data, allTemplates }) {
  const tpl = (allTemplates || []).find((t) => t.slug === template);
  const layout = (tpl && tpl.layout) || "classic";
  // Theme: template default, overridable per-resume via data.options.theme.
  const themeSlug = (data?.options?.theme) || (tpl && tpl.theme) || "navy";
  const accent = (THEMES[themeSlug] || THEMES.navy).accent;
  const options = { ...DEFAULT_OPTIONS, ...((tpl && tpl.options) || {}), ...((data && data.options) || {}) };
  const Component = LAYOUTS[layout] || LAYOUTS.classic;

  // Merge a sensible default photo style: if user uploaded a photo and the layout has a sidebar / banner, show it.
  if (data?.contact?.photo && options.photo_style === "none") {
    if (["sidebar_left", "sidebar_right", "magazine"].includes(layout)) options.photo_style = "round";
    else if (["banner_top", "creative"].includes(layout)) options.photo_style = "banner";
    else if (["photo_top"].includes(layout)) options.photo_style = "round";
  }

  return (
    <div
      className="resume-sheet"
      id="resume-print-target"
      style={themeVars(themeSlug)}
      data-layout={layout}
      data-theme={themeSlug}
    >
      <Component data={data} accent={accent} options={options} />
    </div>
  );
}
